// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:42Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Serviska pro práci s objekty. Generated from cz.marbes.api.objekt.ObjektService.
 */
export default class ObjektApi {
    /**
     * Vrátí objekt podle id. U lokálních objektů vrátí všechny data. U externích poze informace z Eobj_objekt (id v KN, popis, ...).
     *
     * @param id 
     * @return objekt
     */
    static findById(id : number) : Promise<AbstractObjekt> {
        const uri = serverContextPath + `/api/objekt/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Najde id objektů podle id v ENO.
     *
     * @param enoIds 
     * @return id objektu / id v ENO
     */
    static findObjektIdByEnoIds(enoIds : BigInteger[]) : Promise<{[key: number]: BigInteger}> {
        const uri = serverContextPath + `/api/objektyId/enoIds`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, enoIds, headers));
    }

    /**
     * Najde id objektů podle id v ext systemu.
     *
     * @param extIds 
     * @param zdroj 
     * @return id objektu / id v ext systemu
     */
    static findObjektIdByExtIds(extIds : ObjektExtID[], zdroj : ZdrojObjektu) : Promise<{[key: number]: BigInteger}> {
        const uri = serverContextPath + `/api/objektyId/extIds/${zdroj}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, extIds, headers));
    }

    /**
     * Načtení číselníku typ komunikace.
     *
     * @return 
     */
    static getTypKomunikace() : Promise<TypKomunikace[]> {
        const uri = serverContextPath + `/api/objekty/typKomunikace`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizuje lokalni objekt.
     *
     * @param objektInput 
     * @return 
     */
    static updateObjektLocal(objektInput : AbstractObjekt) : Promise<AbstractObjekt> {
        const uri = serverContextPath + `/api/objekt/local`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateAbstractObjekt_5F61A6(objektInput), headers));
    }

    /**
     * Najde zaznam o objektech podle id z katastru.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */
    static findObjektByKn(idKn : BigInteger, typObjekt : EnumKnTypObjekt) : Promise<AbstractObjekt[]> {
        const uri = serverContextPath + `/api/objektByKn`;
        const headers = undefined;
        const params = { idKn, typObjekt };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení číselníku druhu povrchu.
     *
     * @return 
     */
    static getDruhPovrchu() : Promise<DruhPovrchu[]> {
        const uri = serverContextPath + `/api/objekty/druhPovrchu`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení číselníku strana komunikace.
     *
     * @return 
     */
    static getStranaKomunikace() : Promise<StranaKomunikace[]> {
        const uri = serverContextPath + `/api/objekty/stranaKomunikace`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * smaže lokální údaje o objektu.
     *
     */
    static deleteObjekt() {
        const uri = serverContextPath + `/api/objekt/{id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Vrátí obsah číselníku typů objektů.
     *
     * @return typy objektů
     */
    static getTypObjektu() : Promise<TypObjektu[]> {
        const uri = serverContextPath + `/api/objekty/typObjektu`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoří záznam o objektu v lokální databázi, ale data jsou v externím systému.
     *
     * @param objektResult 
     * @return 
     */
    static createObjekt(objektResult : ObjektSearchResult) : Promise<AbstractObjekt> {
        const uri = serverContextPath + `/api/objekt`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateObjektSearchResult_0273A3(objektResult), headers));
    }

    /**
     * Najde id objektu podle id z KN.
     *
     * @param idKn 
     * @param typObjekt 
     * @return 
     */
    static findObjektIdByKnId(idKn : BigInteger, typObjekt : EnumKnTypObjekt) : Promise<number[]> {
        const uri = serverContextPath + `/api/objektyIdByKn`;
        const headers = undefined;
        const params = { idKn, typObjekt };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvori objekt v lokální databázi.
     *
     * @param objektResult 
     * @return 
     */
    static createObjektLocal(objektResult : AbstractObjekt) : Promise<AbstractObjekt> {
        const uri = serverContextPath + `/api/objekt/local`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateAbstractObjekt_5F61A6(objektResult), headers));
    }

    /**
     * Najde polohu objektu v KN.
     *
     * @param idObjektList id objektu v eobj.
     * @return 
     */
    static getObjektGeometry(idObjektList : number[]) : Promise<Poloha[]> {
        const uri = serverContextPath + `/objekt/poloha`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, idObjektList, headers));
    }

    /**
     * Najde objekty dle předaných parametrů.
     *
     * @param query fulltextový dotaz
     * @param obec omezení hledání za kód obce
     * @param ku omezení hledání za kód katastrálního území
     * @param zaklTyp omezení hledání dle záklaního typu objektu
     * @param typ omezení hledání dle kódů typů objektů
     * @param zdroj omezení hledání na zdroj dat
     * @param max omezení počtu vrácených záznamů
     * @return nalezené objekty
     */
    static findObjektFulltext(query : string, obec : string, ku : number, zaklTyp : EnumTypObjekt[], typ : string[], zdroj : ZdrojObjektu[], max : number) : Promise<ObjektSearchResult[]> {
        const uri = serverContextPath + `/api/objekt`;
        const headers = undefined;
        const params = { query, obec, ku, zaklTyp, typ, zdroj, max };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí objekty podle jejich id v lokálním systému. Data o objektech jsou získány z externích systémů, nebo lokálních pokud jsou uložena pouze v databázi. Pokud jsou požadována pouze lokální data použijte {@link #findObjektByIds(List)}.
     *
     * @param idObjektList 
     * @return 
     */
    static findObjektByIds(idObjektList : number[]) : Promise<AbstractObjekt[]> {
        const uri = serverContextPath + `/api/objekty/ids`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, idObjektList, headers));
    }

}